import { render } from "./FormularioDesconto.vue?vue&type=template&id=59264b68&scoped=true"
import script from "./FormularioDesconto.vue?vue&type=script&lang=js"
export * from "./FormularioDesconto.vue?vue&type=script&lang=js"

import "./FormularioDesconto.vue?vue&type=style&index=0&id=59264b68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59264b68"]])

export default __exports__